import { render, staticRenderFns } from "./mod2-1.vue?vue&type=template&id=56212d9c&scoped=true&"
import script from "./mod2-1.vue?vue&type=script&lang=js&"
export * from "./mod2-1.vue?vue&type=script&lang=js&"
import style0 from "./mod2-1.vue?vue&type=style&index=0&id=56212d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56212d9c",
  null
  
)

export default component.exports